/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbUrgency_item$ref = any;
export type PdpSharedBlurbUrgency_item = {
    readonly urgency: {
        readonly pdpBlurbDisplayInfo: {
            readonly key: string | null;
            readonly displayTitle: string | null;
            readonly displaySubtitle: string | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedBlurbUrgency_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbUrgency_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "urgency",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                }
            ],
            "concreteType": "Urgency",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pdpBlurbDisplayInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PdpBlurbDisplayInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "key",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayTitle",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displaySubtitle",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'afd23175263753bf14341c466103cf46';
export default node;
